export interface PostResponseDocumentSubtypesRequestBody {
  fields: string[];
  filters: Record<string, unknown>;
  limit: number;
  offset: number;
}

export interface DbResponseDocumentSubtype {
  id: number;
  name: string;
  displayed_name: string;
  scope: string;
}

export interface ResponseDocumentSubtypesApiResponse {
  data: DbResponseDocumentSubtype[];
}

export interface ResponseDocumentSubtype {
  id: number;
  name: string;
  displayedName: string;
  scope: string;
}

export const SUBTYPE_OTHER_NAME = 'autre';
export const SUBTYPE_OTHER_DISPLAYED = 'Autre';

/** The one subtype the automatic selection cannot do without — see the library health states. */
export const SUBTYPE_MEMOIRE_NAME = 'memoire_technique_anterieur';

export const SCOPE_DCE = 'dce';
export const SCOPE_INTERNAL_DOC = 'internal_doc';
export type DocumentScope = typeof SCOPE_DCE | typeof SCOPE_INTERNAL_DOC;
